import { render, staticRenderFns } from "./teacher-profile.vue?vue&type=template&id=0b752e02&scoped=true"
import script from "./teacher-profile.vue?vue&type=script&lang=js"
export * from "./teacher-profile.vue?vue&type=script&lang=js"
import style0 from "./teacher-profile.vue?vue&type=style&index=0&id=0b752e02&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b752e02",
  null
  
)

export default component.exports